import React, { FC, Fragment } from 'react';
import styled, { css } from 'styled-components';
import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { CourseCard } from 'src/common/components/CourseCard';
import { ListingItem } from 'src/common/components/ListingItems';
import { CourseExcerpt } from 'src/common/models/courseExcerpt';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';
import { Banner } from 'src/common/components/Banner';
import { useMediaQuery } from 'src/common/migration/useMediaQuery';
import { splitAt } from 'ramda';
import { isEmpty } from 'lodash';

const ListingResults = styled.div`
  margin-top: 1.25rem;

  ${media.w.min.px576(css`
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(auto-fill, 13.25rem);
  `)};

  ${media.w.min.px768(css`
    padding: 0 1.5rem;
  `)};

  ${media.w.min.px992(css`
    padding: 0;
  `)};
`;

const BannerContainer = styled.div<{ $withStart: boolean }>`
  ${({ $withStart }) =>
    $withStart &&
    css`
      grid-row-start: 3;
    `}

  grid-column: 1 / -1;

  margin-bottom: 1.5rem;

  ${media.w.min.px576(css`
    margin-bottom: 0;
  `)};
`;

export const CourseListingResult: FC<{
  data: CourseExcerpt[] | undefined;
  viewType: CourseViewType | null;
}> = ({ data, viewType }) => {
  const isMobile = useMediaQuery({ maxWidth: below(widthBreakpoints.px576) });

  if (!data) {
    return <></>;
  }

  const [before, after] = isMobile ? splitAt(2, data) : [data, []];

  return (
    <ListingResults>
      {before.map((excerpt) => (
        <ListingItem key={excerpt.courseId}>
          <CourseCard largeMobileImage courseExcerpt={excerpt} />
        </ListingItem>
      ))}

      {viewType && (
        <BannerContainer $withStart={!isEmpty(data)}>
          <Banner viewType={viewType} />
        </BannerContainer>
      )}

      {after.map((excerpt) => (
        <ListingItem key={excerpt.courseId}>
          <CourseCard largeMobileImage courseExcerpt={excerpt} />
        </ListingItem>
      ))}
    </ListingResults>
  );
};
